import axios from "axios";
import React, {Component} from "react";
import FeatherIcon from 'feather-icons-react';
import ReactToPrint from "react-to-print";
import Listprint from "../../Listprint";
import SpotForm from "./SpotForm";

class   Spot extends Component{

    state = {
        isModal : false,
        formData : null,
        time_end : null,
        spots : [],
    }

    componentDidMount(){
        this.getSpot();
    }

    handleInputM = (e) => {
        this.getSpot();
        this.setState({
            [e.target.name]: e.target.value
        }); 
    }

    async getSpot(){
        this.setState({ spots : [] })
        var spots = await axios.get('spots');
        if(spots.status === 200)
        {
            this.setState({spots : spots.data}) 
        }
    }

    showModal = (spot = null) => {
        this.setState({
            isModal : !this.state.isModal,
            formData : spot,
        })
        this.getSpot();
    }

    handleInput = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        }); 
    }

    delete = (spot) =>{
        axios.delete("spots/" + spot).then((response) => {
            this.getSpot()
        }).catch((error)=>{})
    }

  handleCheck(val) {
    var permissions = localStorage.getItem("permissions") ? JSON.parse(localStorage.getItem("permissions")) : [];
     return  permissions.some(item => val === item.permission);
 }

    render(){
        var rows = [], columns = [
            {
                label: 'Référence',
                field: 'reference',
                sort: 'asc',
                width: 50
            },
            {
                label: 'Emplacement',
                field: 'spot',
                sort: 'asc',
                width: 50
            },
            {
                label: 'Livre',
                field: 'countbook',
                sort: 'asc',
                width: 50
            },
            {
                label: '#',
                field: 'action',
                sort: 'asc',
                width: 50,
                class: 'table_action'
            },
        ];
        this.state.spots.map((spot) => {
            
            rows.push({
                reference : spot.reference,
                spot : spot.spot,
                countbook : spot.books.length,
                action : <span className="table_action">
                        {
                            this.handleCheck("Modifier emplacement") == true && (
                                <div className="widget-todo-item-action d-flex align-items-center">
                                    <FeatherIcon icon="edit-2" size="16" className='cursor-move text-primary' type="button" onClick={() => this.showModal(spot)}></FeatherIcon>
                                </div>
                            )
                        }
                </span>
            })
        })
        return(
            <div>
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                <h5 className="h5 font-monospace">Emplacement des livres</h5>
                {
                    this.handleCheck("Ajouter emplacement") == true && (
                        <div className="btn-toolbar mb-2 mb-md-0">
                            <div className="btn-group me-2">
                                <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => this.showModal(null)}><FeatherIcon icon="plus-circle" ></FeatherIcon></button>
                            </div>
                        </div>
                    )
                }
            </div>
            

            <div className="card shadow mb-2">
                <div className="card-body">
                    <div className="row overflow-auto mt-2">
                        {
                            rows.length > 0 && (
                                <Listprint columns={columns} rows={rows} title={"Les differents emplacements"}/>
                            )
                        }
                    </div>
                </div>
            </div>

            <SpotForm
                isModal={this.state.isModal} 
                formData={this.state.formData} 
                showModal={this.showModal}
            />

        </div>
        )
    }
}
export default Spot;
